module.exports = __webpack_public_path__ + "static/img/8.7803e05.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/zh/8.png
// module id = iYCc
// module chunks = 0